import { render, staticRenderFns } from "./AdvertisementList.vue?vue&type=template&id=82d79c44&scoped=true"
import script from "./AdvertisementList.vue?vue&type=script&lang=js"
export * from "./AdvertisementList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "82d79c44",
  null
  
)

export default component.exports